import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import FadeWrapper from "../../components/FadeWrapper/FadeWrapper";

export default function Skills(props) {
  const theme = props.theme;
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <FadeWrapper direction="bottom" duration={2} distance={20}>
          <h1 className="skills-header" style={{ color: theme.text }}>
            Here's what I do
          </h1>
        </FadeWrapper>
      </div>
      <SkillSection theme={theme} />
    </div>
  );
}
